import SimplePageHeader from '@/header/SimplePageHeader';
import React from 'react';
import MyMoneyTabs from '@/money/views/MyMoneyTabs';

export function MyMoneyHeader({ active }) {
    return (
        <SimplePageHeader pageFixerClassName="tabs">
            <MyMoneyTabs active={active} />
        </SimplePageHeader>
    );
}

export default MyMoneyHeader;
